export default __webpack_public_path__ + "static/media/portfolio_logo_black.cbb82d94.svg";